import {fetchInductProcessData, setInductProcessDetails} from "../network/InductManagementNetworkAPI";

export const InductProcessReducer = (state, action) => {
    switch (action.type) {

        case "FETCH_INDUCT_PROCESS_DATA":

            const {dispatcher} = action.payload;
            fetchInductProcessData(dispatcher)
            return {
                ...state,
                loading: true,
                message: null
            };

        case "FETCH_INDUCT_PROCESS_DATA_SUCCESS":

            if (!action.payload.inductProcessData.isNodeEnabled) {
                return {
                    ...state,
                    loading: false,
                    message: "induct_management.non_mco_station"
                };
            }

            if (!action.payload.inductProcessData.cycleDetailsList &&
                !action.payload.inductProcessData.nodeInductProcessDetails) {
                return {
                    ...state,
                    loading: false,
                    items: {
                        ...state.items,
                        isNodeEnabled: true
                    }
                };
            }

            if (!action.payload.inductProcessData.nodeInductProcessDetails) {
                return {
                    ...state,
                    loading: false,
                    items: {
                        ...state.items,
                        isNodeEnabled:true,
                        cycleDetailsList: action.payload.inductProcessData.cycleDetailsList
                    }
                }
            }

            if (!action.payload.inductProcessData.cycleDetailsList) {
                return {
                    ...state,
                    loading: false,
                    lastCycle: action.payload.inductProcessData.nodeInductProcessDetails.currentCycleDetails,
                    currentForceInductStatus : action.payload.inductProcessData.nodeInductProcessDetails.isForcedInductEnabled,
                    items: {
                        ...state.items,
                        isNodeEnabled: true
                    }
                }
            }

            return {
                ...state,
                loading: false,
                items: action.payload.inductProcessData,
                lastCycle: action.payload.inductProcessData.nodeInductProcessDetails.currentCycleDetails,
                currentForceInductStatus : action.payload.inductProcessData.nodeInductProcessDetails.isForcedInductEnabled
            };

        case "SET_INDUCT_PROCESS_DATA":

            const {nodeInductProcessDetailsRequest, callDispatcher} = action.payload;
            setInductProcessDetails(nodeInductProcessDetailsRequest, callDispatcher)
            return {
                ...state,
                loading: true,
                message: null
            };

        case "SET_INDUCT_PROCESS_DATA_SUCCESS":

            return {
                ...state,
                loading: false,
                items: {
                    ...state.items,
                    nodeInductProcessDetails: {
                        ...state.items.nodeInductProcessDetails,
                        currentCycleDetails: {
                            ...state.items.nodeInductProcessDetails.currentCycleDetails,
                            cycleState: "INDUCT_STARTED"
                        }
                    }
                },
                lastCycle: state.items.nodeInductProcessDetails.currentCycleDetails,
                currentForceInductStatus: state.items.nodeInductProcessDetails.isForcedInductEnabled,
                setNodeInductProcessDetailsModalState : true
            };

        case "API_FAILURE":

            return {
                ...state,
                loading: false,
                message: action.payload.message,
            };

        case "TOGGLE_FORCE_INDUCT_CHANGE":

            return {
                ...state,
                loading: false,
                items: {
                    ...state.items,
                    nodeInductProcessDetails: {
                        ...state.items.nodeInductProcessDetails,
                        isForcedInductEnabled: action.forceInduct === "true"
                    }
                }
            };

        case "CYCLE_SELECTION":
            const cycleList = state.items.cycleDetailsList;
            if (cycleList) {
                const currentCycle = cycleList.filter(cycle => {
                    return cycle.cycleName === action.selectedCycle
                }).shift();
                return {
                    ...state,
                    loading: false,
                    items: {
                        ...state.items,
                        nodeInductProcessDetails: {
                            ...state.items.nodeInductProcessDetails,
                            currentCycleDetails: {
                                ...currentCycle,
                                cycleState: "INDUCT_STARTED"
                            }
                        }
                    }
                };
            }

            return {
                ...state,
                loading: false,
            };


        case "SET_INDUCT_PROCESS_DETAILS_MODAL_STATE":

            return {
                ...state,
                setNodeInductProcessDetailsModalState : false
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/inductManagement/reducers/InductProcessReducer.js